import React from 'react'
import { ContentColumn } from '../..'
import BenchmarkingPlaceholder from '../../components/BenchmarkingPlaceholder'

// "Handläggaranvändning" — intern vy med endast inloggad kommuns data
// (handläggarnamn delas inte mellan kommuner).
export const benchmarkingCalculationCaseworkerUsage: ContentColumn[] = [
  {
    pageTitle: 'Handläggaranvändning',
    content: (
      <BenchmarkingPlaceholder
        text={
          <>
            <b>Beskrivning</b>
            <br />
            Hur beräkningsstödet används internt: antal beräkningar per användare samt genomsnittlig
            beräknad tid per handläggare.
            <br />
            <br />
            <b>Status</b>
            <br />
            Strukturen är på plats. Endast den inloggade kommunens data visas — handläggarnamn delas
            aldrig mellan kommuner.
          </>
        }
      />
    ),
  },
]
